/*
 * FSK hero background video — guarded, deferred source-swap.
 * MEDIA-PIPELINE-SPEC §8.4: the poster (<img>) is the LCP and always renders.
 * Video bytes are NEVER fetched until this runs, and are skipped entirely when
 * motion/data should be conserved. No @theme/component coupling on purpose.
 *
 *  - prefers-reduced-motion: reduce  -> poster stays, no fetch
 *  - Save-Data: on                   -> poster stays, no fetch
 *  - effectiveType in slow-2g/2g/3g  -> poster stays, no fetch
 *  - no-JS                           -> poster stays (sources carry only data-src)
 *  - autoplay blocked                -> poster stays (play() promise rejection swallowed)
 */
(function () {
  var video = document.querySelector('video[data-fsk-hero-video]');
  if (!video) return;

  // Reduced motion — never load the clip.
  var rm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  if (rm && rm.matches) return;

  // Connection-aware degrade.
  var conn = navigator.connection || navigator.webkitConnection || navigator.mozConnection || {};
  if (conn.saveData) return;
  var et = conn.effectiveType || '';
  if (et === 'slow-2g' || et === '2g' || et === '3g') return;

  var sources = video.querySelectorAll('source[data-src]');
  if (!sources.length) return;

  var started = false;
  function start() {
    if (started) return;
    started = true;
    // Promote deferred sources, then load + play.
    for (var i = 0; i < sources.length; i++) {
      var el = sources[i];
      var url = el.getAttribute('data-src');
      if (url) el.setAttribute('src', url);
    }

    video.addEventListener('playing', function () {
      video.classList.add('is-playing');
    }, { once: true });

    video.load();
    var playPromise = video.play && video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () { /* autoplay blocked — poster remains */ });
    }
  }

  // 2026-10-07 (speed, N-web-defects). The clip used to start at `defer`, so its 1.3 MB
  // competed with the rest of the page on a slow phone, and when it began playing Chrome
  // re-recorded it as the largest paint: 6.7 s (poster) became 17.9 s (video) in the lab.
  // Now it waits for the page's load event. On phone widths it also waits for the visitor's
  // first scroll, touch or key press (counted from the start, so one made while the page was
  // still loading is not lost): a visitor who leaves at once never pays for it, and
  // largest-paint recording stops at first input, so the poster stays the measured paint.
  var phone = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  var loaded = document.readyState === 'complete', interacted = !phone;
  var evs = ['scroll', 'touchstart', 'pointerdown', 'keydown'];
  function onInput() {
    evs.forEach(function (n) { document.removeEventListener(n, onInput, true); });
    interacted = true;
    if (loaded) start();
  }
  if (phone) evs.forEach(function (n) { document.addEventListener(n, onInput, { capture: true, passive: true }); });
  if (loaded) { if (interacted) start(); }
  else window.addEventListener('load', function () { loaded = true; if (interacted) start(); }, { once: true });
})();
